
import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
import NotFound from "@/pages/NotFoundPage.vue";
 
const PGConsultaSecop  = () => import(/* webpackChunkName: "common" */ "@/pages/PGConsultaSecop.vue");
const PGConsultaUnspsc = () => import(/* webpackChunkName: "common" */ "@/pages/PGConsultaUnspsc.vue");
const PGDatosSecop     = () => import(/* webpackChunkName: "common" */ "@/pages/PGDatosSecop.vue");
const PGDatosSector    = () => import(/* webpackChunkName: "common" */ "@/pages/PGDatosSector.vue");
const PGConsultaPAA    = () => import(/* webpackChunkName: "common" */ "@/pages/PGConsultaPAA.vue");

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/consulta-secop",
    children: [
      { path: "consulta-secop",  name: "ConsultaSecop",  component: PGConsultaSecop  },
      { path: "consulta-unspsc", name: "ConsultaUnspsc", component: PGConsultaUnspsc },
      { path: "datos-secop",     name: "DatosSecop",     component: PGDatosSecop     },
      { path: "datos-sector",    name: "DatosSector",    component: PGDatosSector    },
      { path: "consulta-paa",    name: "ConsultaPAA",    component: PGConsultaPAA    },
    ],
  },
  { path: "*", component: NotFound },
];
 
export default routes;
 